import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeApprovedSubstance } from "../Entity/TreeNodeApprovedSubstance";
import { TreeNodeDevelopmentSubstance } from "../Entity/TreeNodeDevelopmentSubstance";
import { TreeNodeSubstanceAliasList } from "./TreeNodeSubstanceAliasList";
import { TreeNodeSubstanceAttachmentFieldsList } from "./TreeNodeSubstanceAttachmentFieldsList";
import { TreeNodeSubstanceInternationalCodeList } from "./TreeNodeSubstanceInternationalCodeList";
import { TreeNodeSubstanceParentCodeFieldsList } from "./TreeNodeSubstanceParentCodeFieldsList";
import { TreeNodeSubstancePreviousEvCodeFieldsList } from "./TreeNodeSubstancePreviousEvCodeFieldsList";
import { TreeNodeSubstancePreviousNameCodeFieldsList } from "./TreeNodeSubstancePreviousNameCodeFieldsList";
import { TreeNodeSubstanceTranslationList } from "./TreeNodeSubstanceTranslationList";
import { Art57Section } from "../../../Art57Section/Art57Section";


export class TreeNodeSubstancesList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Substances ({param})');
      this.parent = parent;
      this.labelNodeName = 'Substances';      
      this.expanded = true;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      const authorisedRequestedNode: boolean = params.nodeTypeToCreateName == 'addApprovedSubstance';
  
      let nodeCreated: Art57Node[] | null;

      if (authorisedRequestedNode) {

        let approvedNode = new TreeNodeApprovedSubstance(this.ioc!, this);
        if ((params.operationType === 1) && (this.ioc!.get(Art57Section).isCreateAndSendProductSection() || this.ioc!.get(Art57Section).isMedicinalProductSection())) { // only operationtype insert has localnumber
          approvedNode.data.model.localnumber = this.ioc!.get(LookupGetService).getLocalNumber(); 
        }
    
        let approvedSubstanceNodes: Art57Node[] = [];
        approvedSubstanceNodes.push(
          new TreeNodeSubstanceTranslationList(this.ioc!, approvedNode)
        );
        approvedSubstanceNodes.push(
          new TreeNodeSubstanceAliasList(this.ioc!, approvedNode)
        );
        approvedSubstanceNodes.push(
          new TreeNodeSubstanceInternationalCodeList(this.ioc!, approvedNode)
        );
        approvedSubstanceNodes.push(
          new TreeNodeSubstanceParentCodeFieldsList(this.ioc!, approvedNode)
        );
        approvedSubstanceNodes.push(
          new TreeNodeSubstancePreviousEvCodeFieldsList(this.ioc!, approvedNode)
        );
        approvedSubstanceNodes.push(
          new TreeNodeSubstanceAttachmentFieldsList(this.ioc!, approvedNode)
        );
    
        approvedSubstanceNodes.map((nodeToAdd) => {
          approvedNode.children?.push(nodeToAdd);
        });
        this.refreshLabel();
        nodeCreated= [approvedNode];

      } else {


        let developmentNode = new TreeNodeDevelopmentSubstance(this.ioc!, this);
        if ((params.operationType === 1) && (this.ioc!.get(Art57Section).isCreateAndSendProductSection() || this.ioc!.get(Art57Section).isMedicinalProductSection())) { // only operationtype insert has localnumber
          developmentNode.data.model.localnumber = this.ioc!.get(LookupGetService).getLocalNumber(); 
        }
    
        let developmentSubstanceNodes: Art57Node[] = [];
    
        developmentSubstanceNodes.push(
          new TreeNodeSubstancePreviousNameCodeFieldsList(this.ioc!, developmentNode)
        );
        developmentSubstanceNodes.push(
          new TreeNodeSubstanceInternationalCodeList(this.ioc!, developmentNode)
        );
        developmentSubstanceNodes.push(
          new TreeNodeSubstanceParentCodeFieldsList(this.ioc!, developmentNode)
        );
        developmentSubstanceNodes.push(
          new TreeNodeSubstanceAttachmentFieldsList(this.ioc!, developmentNode)
        );
    
        developmentSubstanceNodes.map((nodeToAdd) => {
          developmentNode.children?.push(nodeToAdd);
        });
        this.refreshLabel();
        nodeCreated = [developmentNode];

      }
      
      if (nodeCreated) {
        this.children?.push(nodeCreated[0]);
      }
  
      this.refreshLabel();
      return nodeCreated;
    }
  
    override getMessage(): any {
      let message = {};
      let approvedSubstances: any[] = [];
      let developmentSubstances: any[] = [];
  
      this.children?.forEach((node) => {
        let art57Node = node as Art57Node;
        let art57Message = art57Node.getMessage();
        if (art57Message != null) {
          if (art57Node instanceof TreeNodeApprovedSubstance) {
            approvedSubstances.push(art57Message);
          } else if (art57Node instanceof TreeNodeDevelopmentSubstance) {
            developmentSubstances.push(art57Message);
          }
        }
      });
  
      let approvedSubstancesMessage = null;
      if (approvedSubstances.length > 0) {
        approvedSubstancesMessage = {
          approvedsubstances: { approvedsubstance: approvedSubstances },
        };
        message = { ...message, ...approvedSubstancesMessage };
      }
  
      let developmentSubstancesMessage = null;
      if (developmentSubstances.length > 0) {
        developmentSubstancesMessage = {
          developmentsubstances: { developmentsubstance: developmentSubstances },
        };
        message = { ...message, ...developmentSubstancesMessage };
      }
  
      return { ...message };
    }
  
    override isSubstancesList(): boolean {
      return true;
    }
  
    override getHeaders(): string[] {
      return ['EV Code','Operation Type', 'Type', 'Substance Name'];
    }
  }